<div class="fb-default-field-wrapper w-full">
  <div class="fb-field-label-container" *ngIf="label">
    <label class="fb-field-label" [class.disable-label]="disable || readonly || numberControl.disabled">
      {{ label }}
      <span class="required-asterisk" *ngIf="required">*</span>
    </label>
  </div>
  <mat-form-field
    [appearance]="appearance || 'outline'"
    floatLabel="always"
    class="w-full fb-custom-outline"
    [class.is-invalid]="numberControl.invalid && (numberControl.touched || numberControl.dirty)"
    [class.is-filled]="numberControl.value !== null && numberControl.value !== undefined && numberControl.value !== ''"
  >
    <fb-anex
      *ngIf="prefix && prefix.type !== 'text'"
      matPrefix
      [config]="prefix"
      [control]="control"
      [templates]="templates"
      position="start"
    ></fb-anex>

    <input
      class="number-input"
      type="text"
      matInput
      fbDisableAutocomplete
      mask="{{ useCommaSeparator | numberFieldMask : digitsCount }}"
      [thousandSeparator]="useCommaSeparator ? ',' : undefined"
      [prefix]="prefixText"
      [validation]="true"
      [allowNegativeNumbers]="min === undefined || min < 0"
      [formControl]="numberControl"
      [placeholder]="placeholder"
      [required]="required"
      [fbDisableControl]="disable || readonly || numberControl.disabled"
      [minlength]="minlength"
      [maxlength]="maxlength"
      [readonly]="readonly"
      (focusout)="onTouched()"
    />

    <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
      <fb-anex
        *ngIf="suffix"
        [style.margin-right.px]="0"
        matSuffix
        [config]="suffix"
        [control]="ngControl.control"
        [templates]="templates"
        position="end"
      ></fb-anex>
    </ng-container>

    <ng-template #showLoader>
      <fb-loader class="position-relative loader" [size]="20" [message]="undefined" matSuffix></fb-loader>
    </ng-template>
  </mat-form-field>

  <div class="fb-field-subscript-absolute">
    <fb-validation-error
      *ngIf="
        numberControl.invalid && (numberControl.touched || numberControl.dirty) && (loading.active$ | async) === false
      "
      [control]="numberControl"
      [label]="label"
    ></fb-validation-error>
  </div>
</div>
